module.exports = __webpack_public_path__ + "static/passkeys-0583e5b7d982ec495fc332e302bc0e08.png";